import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { db } from "../firebase/firebase";
import { collection, addDoc } from "firebase/firestore";

export default function AddStudent() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    const [student, setStudent] = useState({
        fullName: "",
        mobile: "",
        status: "new",
        notes: "",
        totalFees: "",
        admissionDate: "",
        classStartDate: "",
        feesReceived: [],
        createdAt: new Date(),
    });

    const handleChange = (e) => {
        setStudent({
            ...student,
            [e.target.name]: e.target.value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            await addDoc(collection(db, "students"), student);
            alert("Student Added Successfully ✅");
            navigate("/dashboard/students");
        } catch (err) {
            console.error(err);
            alert("Failed to add student ❌");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-slate-950 via-slate-900 to-black px-6 py-8 text-white">

            {/* Header */}
            <div className="flex justify-between items-center mb-8">
                <h1 className="text-3xl font-bold text-orange-500">
                    Add Student
                </h1>

                <button
                    onClick={() => navigate("/dashboard/students")}
                    className="text-sm text-gray-300 hover:text-white"
                >
                    ← Back to Students
                </button>
            </div>

            <form onSubmit={handleSubmit} className="space-y-6 max-w-6xl">

                {/* ---------- BASIC INFO ---------- */}
                <div className="bg-white/10 backdrop-blur-xl p-6 rounded-2xl border border-white/10">
                    <h2 className="text-lg font-semibold mb-4 text-orange-400">
                        Basic Information
                    </h2>

                    <div className="grid md:grid-cols-3 gap-4">

                        <Input
                            name="fullName"
                            value={student.fullName}
                            onChange={handleChange}
                            placeholder="Full Name"
                            required
                        />

                        <Input
                            name="mobile"
                            value={student.mobile}
                            onChange={handleChange}
                            placeholder="Mobile Number"
                            required
                        />

                        <Select
                            name="status"
                            value={student.status}
                            onChange={handleChange}
                            options={[
                                { value: "new", label: "New" },
                                { value: "approved", label: "Approved" },
                                { value: "admitted", label: "Admitted" },
                                { value: "rejected", label: "Rejected" },
                            ]}
                        />
                    </div>
                </div>

                {/* ---------- FEES ---------- */}
                <div className="bg-white/10 backdrop-blur-xl p-6 rounded-2xl border border-white/10">
                    <h2 className="text-lg font-semibold mb-4 text-orange-400">
                        Fees & Dates
                    </h2>

                    <div className="grid md:grid-cols-3 gap-4">

                        <Input
                            type="number"
                            name="totalFees"
                            value={student.totalFees}
                            onChange={handleChange}
                            placeholder="Total Fees"
                        />

                        <Input
                            type="date"
                            name="admissionDate"
                            value={student.admissionDate}
                            onChange={handleChange}
                        />

                        <Input
                            type="date"
                            name="classStartDate"
                            value={student.classStartDate}
                            onChange={handleChange}
                        />
                    </div>
                </div>

                {/* ---------- NOTES ---------- */}
                <div className="bg-white/10 backdrop-blur-xl p-6 rounded-2xl border border-white/10">
                    <h2 className="text-lg font-semibold mb-4 text-orange-400">
                        Admin Notes
                    </h2>

                    <textarea
                        name="notes"
                        value={student.notes}
                        onChange={handleChange}
                        className="w-full p-4 rounded-xl bg-black/40 border border-white/20 focus:outline-none focus:ring-2 focus:ring-orange-500"
                        placeholder="Write notes about student..."
                        rows={5}
                    />
                </div>

                {/* ---------- SUBMIT ---------- */}
                <div className="sticky bottom-0 bg-black/60 backdrop-blur-lg p-4 rounded-xl border border-white/10 flex justify-between items-center">

                    <p className="text-sm text-gray-400">
                        Make sure all details are correct before submitting.
                    </p>

                    <button
                        type="submit"
                        disabled={loading}
                        className="bg-orange-500 hover:bg-orange-600 px-6 py-3 rounded-xl font-semibold shadow-lg transition"
                    >
                        {loading ? "Adding..." : "Add Student"}
                    </button>
                </div>

            </form>
        </div>
    );
}

/* ---------- REUSABLE INPUT ---------- */
function Input({ type = "text", ...props }) {
    return (
        <input
            type={type}
            {...props}
            className="w-full p-3 rounded-xl bg-black/40 border border-white/20 focus:outline-none focus:ring-2 focus:ring-orange-500 transition"
        />
    );
}

/* ---------- REUSABLE SELECT ---------- */
function Select({ options = [], ...props }) {
    return (
        <select
            {...props}
            className="w-full p-3 rounded-xl bg-black/40 border border-white/20 focus:outline-none focus:ring-2 focus:ring-orange-500"
        >
            {options.map((opt, i) => (
                <option key={i} value={opt.value}>
                    {opt.label}
                </option>
            ))}
        </select>
    );
}